export const ModulesEnum = {
    AAS: 'AAS',
    AI_MINUTE_BUILDER: 'AI_MINUTE_BUILDER',
    RLOG: 'RLOG',
    MINUTES: 'MINUTES',
    KBASE: 'KBASE',
    DISCUSS: 'DISCUSS',
};
